
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[[...slug]]",
      function () {
        return require("private-next-pages/search/[[...slug]].js");
      }
    ]);
  